export interface Identifiable {
  id: number | string;
}

export const trackById = <T extends Identifiable>(
  _index: number,
  entity: T,
): string => `${entity.id}`;
